import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    appSettings: {
      minLastPriceUpdate: null,
      sellersCategories: [],
      sellersIds: [],
    },
    availableClassificationsSellers: [
      { name: "Google", id: 111 },
      { name: "QMatchBrands", id: 132 },
    ],
    categoriesBySellers: [],
    classifications: [],
    classificationsSellerId: null,
    currentClassification: null,
    getItemsResultMessage: null,
    getValidatedItems: false,
    items: [],
    itemsFetch: 48,
    itemsTotal: null,
    likePatternBrandFilter: null,
    termSample: null,
    likePatternCategoryFilter: null,
    likePatternNameFilter: null,
    loading: {
      samples: false,
      save: false,
      classRanking: false
    },
    loadingCategoriesBySellers: false,
    loadingClassifications: false,
    loadingCreateClassification: false,
    loadingItems: false,
    loadingItemsTotal: false,
    loadingMergeClassifications: false,
    loadingSaveCorrection: false,
    loadingSellersWithPredictions: false,
    notLikePatternFilter: null,
    onlyItemsWithTheirBestPrediction: false,
    samples: [],
    classRanking: [],
    selectedClassificationsForMerge: [],
    showFiltersSidebar: false,
    showClassRankingSidebar: false,
    showItemsWithoutPredictions: true,
    showOnlyCorrectPredictions: false,
    showSamplesSidebar: false,
  },
};
